export enum AgreementStatus {
  ACCEPTED = "accepted",
  REJECTED = "rejected",
  PENDING = "pending",
}

export enum DoctorDocumentType {
  AGREEMENT = "agreement",
  OFFER = "offer",
}
